import type { SupplierOffer } from "@/types/chemistry";

const SUPPLIERS = [
  "Sigma-Aldrich", "TCI Chemicals", "Alfa Aesar", "Merck", "Thermo Fisher",
  "Acros Organics", "Carl Roth", "VWR International", "Fluorochem", "BLD Pharm",
  "Enamine", "Combi-Blocks",
];

const PURITIES = ["≥99%", "≥98%", "≥97%", "≥95%", "≥90%", "technical"];

const PACKAGE_SETS: string[][] = [
  ["5g", "25g", "100g"],
  ["1g", "5g", "25g", "100g", "500g"],
  ["10g", "50g", "250g"],
  ["25g", "100g", "500g", "1kg"],
  ["5g", "10g", "50g"],
  ["1g", "5g"],
];

function seededRandom(seed: number) {
  let s = seed;
  return () => {
    s = (s * 16807 + 0) % 2147483647;
    return s / 2147483647;
  };
}

function hashStr(str: string) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = ((h << 5) - h + str.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function generateMockSupplierOffers(materialName: string, casNumber: string): SupplierOffer[] {
  const seed = hashStr(materialName + casNumber);
  const rand = seededRandom(seed);

  const count = 5 + Math.floor(rand() * 8); // 5-12
  const shuffled = [...SUPPLIERS].sort(() => rand() - 0.5).slice(0, count);

  return shuffled.map((supplier, i) => {
    const pkgSet = PACKAGE_SETS[Math.floor(rand() * PACKAGE_SETS.length)];
    const chosenPkg = pkgSet[Math.floor(rand() * pkgSet.length)];
    const baseCost = 15 + rand() * 400;
    const daysOut = Math.floor(1 + rand() * 21);
    const delivery = new Date();
    delivery.setDate(delivery.getDate() + daysOut);

    return {
      id: `offer-${seed}-${i}`,
      supplierName: supplier,
      itemNumber: `${supplier.substring(0, 2).toUpperCase()}${Math.floor(100000 + rand() * 900000)}`,
      purity: PURITIES[Math.floor(rand() * PURITIES.length)],
      inInventory: rand() < 0.15,
      inStock: rand() < 0.7,
      earliestDelivery: delivery.toISOString().split("T")[0],
      packageSizes: pkgSet,
      packageSizeChosen: chosenPkg,
      cost: Math.round(baseCost * 100) / 100,
      costPerUnit: Math.round((baseCost / parseFloat(chosenPkg)) * 100) / 100,
      co2ePerGram: Math.round(rand() * 0.5 * 1000) / 1000,
    };
  });
}
